import React from "react";
import ReactDOM from 'react-dom';
import { Modal, Button } from "antd";

export const ModalCorreo = ({
    visible,
    confirmDialog,
    enviarCorreo,
    hideModalCorreo,
    correo,
    asunto,
    mensaje,
    caracteresRestantes,
    handleOnChangeModalCorreo,
    visibleConfirma,
    confirmDialogConfirma,
    hideModalConfirmaCorreo,
    mensajeConfirmacion
}) => {
    return ReactDOM.createPortal(
        <div>
            <Modal 
                width="800px"
                visible={visible}
                confirmLoading={confirmDialog}
                onOk={enviarCorreo}
                onCancel={hideModalCorreo}
                okText="Aceptar"
                cancelText="Cancelar"
                closable={true}
                footer={null} >
                <div style={{ textAlign: "left" }}>
                    <p style={{ color: "var(--rosa-ine)" }}> <b> Mensaje Nuevo </b></p>
                    <label> <b> Para: </b>  </label> {correo} <br />
                    <label> <b> Asunto: </b>  </label> {asunto} <br />
                    <label> <b> Mensaje: </b>  </label> <br />

                    <textarea
                        style={{'width':'100%'}}
                        nombre={'mensajeCorreo'}
                        placeholder="Ingresar"
                        rows="10" cols="102"
                        value={mensaje}
                        onChangeCapture={handleOnChangeModalCorreo}
                        maxLength={3000} />
                    <div style={{ 'textAlign': 'justify', 'fontStyle': 'italic' }}>{caracteresRestantes} caracteres restantes.</div>

                </div>
                <div style={{ textAlign: "right" }}>
                    <Button onClick={enviarCorreo} >
                        Enviar
                     </Button>
                </div>
            </Modal>


            <Modal 
                visible={visibleConfirma}
                confirmLoading={confirmDialogConfirma}
                onOk={hideModalConfirmaCorreo}
                onCancel={hideModalConfirmaCorreo}
                okText="Aceptar"
                closable={true}
                footer={null}> 

                <div className="mensaje_confirmacion"> {mensajeConfirmacion} </div>  <br />
                    <div id="modal_botones">
                        <Button onClick={hideModalConfirmaCorreo}>
                            Aceptar
                        </Button>
                </div>
            </Modal>

        </div>,
        document.body
    );
};

export default ModalCorreo;
